<template>
  <div id="app">

    <NavBar />

    <v-app id="main">

      <HomePage  
        v-if="show.home" 
        @show-costs="showCostsSection" />

        <Costs 
          v-if="show.costs"
          @render-cost-average="renderAverage"
          @render-cost-totals="renderTotals"
          @render-final-total="renderTotal"
        />

        <SummaryPage 
          v-if="show.summary"
          :costs="costTotals"
          :finalTotal="finalTotal"
          :average="average"
          :companySize="companySize"
          @return="showCostsSection"
        />

    </v-app>

    <MessageModal />

    <Foot />

  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import HomePage from './components/HomePage.vue';
import Costs from './components/Costs';
import SummaryPage from './components/SummaryPage';

import MessageModal from './components/Modals/Message';

import Foot from './components/Foot.vue';

export default {
  name: 'app',
  data: () =>({
    finalTotal: 0,
    average: null,
    companySize: null,
    show: {
      home: true,
      costs: false,
      summary: false
    },
    costTotals: {
      prevention: 0,
      appraisal: 0,
      internalFailure: 0,
      externalFailure: 0,
      other: 0
    }
  }),
  components: {
    NavBar,
    Costs,
    HomePage,
    SummaryPage,
    MessageModal,
    Foot
  },
  methods: {
    showCostsSection(companySize) {
      this.companySize = companySize;
      this.show.home = false;
      this.show.summary = false;
      this.show.costs = true;
    },
    renderTotals(costs) {
      this.costTotals = costs;
    },
    renderAverage(average) {
      this.average = average;
    },
    renderTotal(finalTotal) {
      this.finalTotal = finalTotal;
      this.show.costs = false;
      this.show.summary = true;
    }
  },
  created: function() {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F2F3FA !important;
}
#main {
  height: 100%;
  width: 100%;
  background: #F2F3FA !important;
  margin-top: 6rem;
}
</style>
